import { Typography } from 'antd';
import { useNavigate } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';
import Card from '@/components/Card';
import Grid from '@/components/list/Grid';
import StatusBadge from '@/components/order/StatusBadge';
import PriceItemBox from '@/components/product/ProductItem/PriceItem';
import type { PRODUCT_ORDER_STATUS } from '@/constants';
import { useProductOrders } from '@/hooks/queries/partner';
import usePagination from '@/hooks/usePagination';

const ProductOrderHistory = () => {
  const pagination = usePagination([], {
    defaultSize: 15,
  });
  const navigate = useNavigate();
  const query = useProductOrders({ ...pagination.query });

  return (
    <Grid
      itemKey={(data) => data.id.toString()}
      headerConfig={{
        showTotalCount: true,
        showSizeSelector: true,
        sizeOptions: [15, 45, 90],
      }}
      dataSource={query.data?.results}
      onClickItem={(data) => {
        navigate(`${PATH.MARKETING_PRODUCT.ORDER_HISTORY}/${data.id}`);
      }}
      emptyText="신청한 내역이 없어요"
      renderItem={(data) => {
        return (
          <Card
            css={[
              tw`[.ant-card-body]:(flex flex-col items-start w-full)`,
              tw`[img]:(w-full aspect-[3/2] object-cover)`,
            ]}
          >
            <img
              alt={`${data.productName} 썸네일`}
              src={data.bannerImageUrl}
              onDragStart={(e) => e.preventDefault()}
            />

            <Typography.Text
              css={tw`mt-[24px] font-semibold leading-[24px] text-[16px] text-black`}
            >
              {data.productName}
            </Typography.Text>
            <Typography.Text css={tw`mt-[8px] leading-[22px] text-[14px]`}>
              {data.summary}
            </Typography.Text>

            <PriceItemBox
              price={data.price}
              discountPrice={data.discountPrice || 0}
              customCss={tw`mb-[20px]`}
            />

            <StatusBadge
              bg="#F0F5FF"
              status={data.status as keyof typeof PRODUCT_ORDER_STATUS}
            />
          </Card>
        );
      }}
      pagination={{ total: query.data?.count, ...pagination }}
    />
  );
};

export default ProductOrderHistory;
